<template>  
  <div>    
    <!-- header -->
    <header class="flex-sup ct-header-hc cvBuilderPageHeader">
      <img
        src="../assets/img/logo-nova-branca.png"
        alt="DTC Treinamentos e consultoria"
        class="ctHead-logo-hc"
      />

      <nav class="flex-sup navBreadcrumbs-hc" style="border-right: none">
        <a href="/"> Centro de Carreiras</a>
        <i class="fas fa-arrow-right"></i>
        <a href="#"> Perfil de empresas </a>
      </nav>

      <!-- botao de finalizar -->
      <div class="flex-sup sair_head sairHeadCv">
        <button
          class="flex-sup btn btn_sair_ct"
          v-if="true"
          @click.prevent="deslogar()"
        >
          <h4>Sair</h4>
        </button>

        <a @click.prevent="deslogar()" class="flex-sup mobOption">
          <span class="material-icons"> logout </span> <small> Sair </small>
        </a>
      </div>
    </header>

    <!-- LOADING -->
    <!-- status: loading -->
    <div class="flex-sup status-alert-wrapper loading-status" v-show="loading">
      <div class="flex-sup status-alert-field">
        <div class="flex-sup alert-title">
          <img src="../assets/img/loading.png" />
          <strong> Carregando... </strong>
        </div>
        <div class="flex-sup alert-desc-close">
          <p>Aguarde alguns instantes.</p>
        </div>
        <a class="flex-sup alert-close">
          <span class="material-icons"> close </span>
        </a>
      </div>
    </div>

    <!-- Modal para refazer login -->
    <div v-show="redirectLogin" class="flex-sup modal-involucro">
      <div class="flex-sup modal-pop">
        <div class="flex-sup corpo-modal">
          <h2>Seu login expirou!</h2>
          <p>Você será redirecionado para a tela de login.</p>
          <div class="flex-sup btn-modal">
            <button class="btn btn-can-ad" @click="redirecionarUsuario()">Ok</button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-sup background_tela_cluster">
      <div class="flex-sup hero_img_cluster">
        <div class="flex-sup img_cluster_home">
          <img src="../assets/img/quiz_empresa.png" />
        </div>
      </div>
      <div class="flex-sup hero_cluster">        
        <h1>
          Quiz de Empresas DNC
        </h1>    
      </div> 
      <p class="hero_cluster_sec_text">Quer saber qual empresa tem a sua cara?</p>    
      <a href="/quiz-perfil-empresa" class="btn btn_start_cluster" @click="envia_evento_cv_builder()">
          <i>Vamos lá!</i>
        </a>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "HomeCluster",
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      toke: '',
      loading: false,
      redirectLogin: false,
      aluno: {},
    };
  },
  methods: {
    /* eslint-disable */
    // Encerrar a sessão
    envia_evento_cv_builder(){
      this.$http.post('https://bhle6w0e86.execute-api.us-east-1.amazonaws.com/event', {
      id: 'iniciou-quiz-empresa',
      aluno: {
        aluno_nome: this.aluno.aluno_nome,
        aluno_id: this.aluno.aluno_id, 
        aluno_email: this.aluno.aluno_email,
        aluno_telefone: this.aluno.aluno_telefone,
      },
      data_evento: new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }),
      link: window.location.href,
      curso: {},
      step: {},
      modulo: {},
      slot: {},
      conteudo: {}
    })
  },
    deslogar() {
      this.$cookies.remove("tokenCarreiras");
      this.$cookies.remove("nomeCarreiras");
      window.location.href = "/";
    },
    // Redirecionar para login
    redirecionarUsuario() {
      this.$cookies.remove("tokenCarreiras");
      window.location.href = "/";
    }
  },
  mounted() {
    this.loading = true;
    // Verificar se existe token de acesso
    this.token = this.$cookies.get("tokenCarreiras");
    if (this.token == null) {
      this.redirectLogin = true;
    }
    this.loading = false;
  }
};
</script>
